module.exports = __webpack_public_path__ + "static/img/plato.8ecb6c7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plato.gif
// module id = fFd4
// module chunks = 4